export function validateLeadsterPlusMenuAccess(
  params, callbackSuccess, callbackError)
{
  return {
    type: "VALIDATE_LEADSTER_PLUS_MENU_ACCESS",
    payload: {
      params,
      callbackSuccess,
      callbackError,
    },
  };
}